import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { Amplify } from 'aws-amplify';
import { environment } from "./environments/environment";

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: environment.cognitoUserPoolId,       // your EU user pool ID
      userPoolClientId: environment.cognitoUserPoolClientID,  // your app client ID
      loginWith: {
        email: true,
      },
      userAttributes: {
        email: {
          required: true,
        }
      },
      signUpVerificationMethod: "code",
      passwordFormat: {
        minLength: 8,
        requireLowercase: true,
        requireUppercase: true,
        requireNumbers: true,
        requireSpecialCharacters: true,
      },
    }
  },
});

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
